import { createAction } from '@reduxjs/toolkit';

import * as actionTypes from './actionTypes';
import type { SocketData } from './types';

export const selectTab = createAction(actionTypes.SELECT_TAB, (tab) => ({
  payload: tab,
}));

export const toggleVat = createAction(actionTypes.TOGGLE_VAT);

export const openInterventionUpdateModal = createAction(
  actionTypes.OPEN_INTERVENTION_UPDATE_MODAL,
  (payload: Pick<SocketData, 'type'>) => ({
    payload,
  })
);

export const closeInterventionUpdateModal = createAction(
  actionTypes.CLOSE_INTERVENTION_UPDATE_MODAL,
  (payload: Pick<SocketData, 'type'>) => ({
    payload,
  })
);

export const openAppointmentBookingModal = createAction(actionTypes.OPEN_APPOINTMENT_BOOKING_MODAL);

export const closeAppointmentBookingModal = createAction(actionTypes.CLOSE_APPOINTMENT_BOOKING_MODAL);

export const setSelectedGroupOffer = createAction(actionTypes.SET_SELECTED_GROUP_OFFER, (id: string) => ({
  payload: id,
}));
